module.exports = __webpack_public_path__ + "static/media/accept-icon.5b6271e9.svg";